
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/data-masking",
      function () {
        return require("private-next-pages/customer-studio/data-masking.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/data-masking"])
      });
    }
  